import { useFlags } from 'launchdarkly-react-client-sdk';

import { useCustomAuth } from 'auth/AuthContext';
import useFeatureSettings from 'hooks/queries/useFeatureSettings';

/**
 * Same rule as {@link NavigationPanel}: tenant `acl_enabled` plus LD `accessControlLayer`.
 * Used where nav visibility and in-page permission UI must stay in sync (e.g. role builder).
 */
export const useACLPermission = () => {
    const { isAuthenticated, isLoading: isAuthLoading } = useCustomAuth();
    const {
        data: featureSettings,
        isSuccess: isFeatureSettingsSuccess,
        isInitialLoading: isFeatureSettingsLoading,
    } = useFeatureSettings({
        enabled: isAuthenticated,
    });
    const { accessControlLayer: accessControlLayerFlag } = useFlags();
    const hasAccessControlLayer = Boolean(featureSettings?.acl_enabled && accessControlLayerFlag);

    const isLoading = isAuthLoading || isFeatureSettingsLoading || accessControlLayerFlag === undefined;

    return {
        hasAccessControlLayer: isFeatureSettingsSuccess && hasAccessControlLayer,
        isLoading,
    };
};
